// Composes this app's full string table (shared/i18n/common.js +
// shared/i18n/admin.js — admin never needs shared/i18n/portal.js's guest/
// OTP/catalog-browse copy) and registers it with shared/i18n/index.js so
// that file's own `t`/`statusLabel` resolve admin's strings — see
// shared/i18n/index.js's header comment for why registration, not a direct
// import, is what keeps portal/ from pulling admin's strings into its own
// bundle. Imported by context/LanguageContext.jsx, which is itself imported
// early enough (App.jsx's provider tree) that this module's top-level
// registerStrings() call always runs before any component calls t().

import { registerStrings, t, statusLabel, LANGUAGES, DEFAULT_LANGUAGE } from 'shared/i18n/index.js';
import commonStrings from 'shared/i18n/common.js';
import adminStrings from 'shared/i18n/admin.js';

registerStrings({ ...commonStrings, ...adminStrings });

export { t, statusLabel, LANGUAGES, DEFAULT_LANGUAGE };
